export default "__VITE_ASSET__BSLb5S0v__"